export const EMPLOYEE_STANDARD_STATUS_ASSIGNED = 'ASSIGNED';
export const EMPLOYEE_STANDARD_STATUS_EXCLUDED = 'EXCLUDED';
export const EMPLOYEE_STANDARD_STATUS_ACTIVE_FROM_OTHER_GROUP = 'ACTIVE_FROM_OTHER_GROUP';
export const EMPLOYEE_STANDARD_STATUS_NOT_APPLICABLE = 'NOT_APPLICABLE';
export const EMPLOYEE_STANDARD_STATUS_READONLY = 'READONLY';

export const EMPLOYEE_STANDARD_STATUS_ASSIGNED_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_STATUS_ASSIGNED';
export const EMPLOYEE_STANDARD_STATUS_EXCLUDED_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_STATUS_EXCLUDED';
export const EMPLOYEE_STANDARD_STATUS_ACTIVE_FROM_OTHER_GROUP_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_STATUS_ACTIVE_FROM_OTHER_GROUP';
export const EMPLOYEE_STANDARD_STATUS_NOT_APPLICABLE_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_STATUS_NOT_APPLICABLE';
export const EMPLOYEE_STANDARD_STATUS_READONLY_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_STATUS_READONLY';

export type EmployeeStandardCellStatus =
  'ASSIGNED' |
  'EXCLUDED' |
  'ACTIVE_FROM_OTHER_GROUP' |
  'NOT_APPLICABLE' |
  'READONLY';

export interface EmployeeStandardStatusMap {
  [status: string]: EmployeeStandardCellStatus;
}

export interface EmployeeStandardStatusTranslationKeyMap {
  [status: string]: string;
}

export const EMPLOYEE_STANDARD_STATUS_VALUES: EmployeeStandardStatusMap = {};
EMPLOYEE_STANDARD_STATUS_VALUES[EMPLOYEE_STANDARD_STATUS_ASSIGNED] = EMPLOYEE_STANDARD_STATUS_ASSIGNED;
EMPLOYEE_STANDARD_STATUS_VALUES[EMPLOYEE_STANDARD_STATUS_EXCLUDED] = EMPLOYEE_STANDARD_STATUS_EXCLUDED;
EMPLOYEE_STANDARD_STATUS_VALUES[EMPLOYEE_STANDARD_STATUS_ACTIVE_FROM_OTHER_GROUP] = EMPLOYEE_STANDARD_STATUS_ACTIVE_FROM_OTHER_GROUP;
EMPLOYEE_STANDARD_STATUS_VALUES[EMPLOYEE_STANDARD_STATUS_NOT_APPLICABLE] = EMPLOYEE_STANDARD_STATUS_NOT_APPLICABLE;
EMPLOYEE_STANDARD_STATUS_VALUES[EMPLOYEE_STANDARD_STATUS_READONLY] = EMPLOYEE_STANDARD_STATUS_READONLY;

export const EMPLOYEE_STANDARD_STATUS_KEYS: EmployeeStandardStatusTranslationKeyMap = {};
EMPLOYEE_STANDARD_STATUS_KEYS[EMPLOYEE_STANDARD_STATUS_ASSIGNED] = EMPLOYEE_STANDARD_STATUS_ASSIGNED_KEY;
EMPLOYEE_STANDARD_STATUS_KEYS[EMPLOYEE_STANDARD_STATUS_EXCLUDED] = EMPLOYEE_STANDARD_STATUS_EXCLUDED_KEY;
EMPLOYEE_STANDARD_STATUS_KEYS[EMPLOYEE_STANDARD_STATUS_ACTIVE_FROM_OTHER_GROUP] = EMPLOYEE_STANDARD_STATUS_ACTIVE_FROM_OTHER_GROUP_KEY;
EMPLOYEE_STANDARD_STATUS_KEYS[EMPLOYEE_STANDARD_STATUS_NOT_APPLICABLE] = EMPLOYEE_STANDARD_STATUS_NOT_APPLICABLE_KEY;
EMPLOYEE_STANDARD_STATUS_KEYS[EMPLOYEE_STANDARD_STATUS_READONLY] = EMPLOYEE_STANDARD_STATUS_READONLY_KEY;

export interface EmployeeStandardUserResponse {
  id: string;
  firstName: string;
  lastName: string;
  positionId: string;
  positionName: string;
}

export interface EmployeeStandardResponse {
  id: string;
  number: string;
  ruName: string;
  enName: string;
}

export interface EmployeeStandardCellResponse {
  standardId: string;
  userId: string;
  status: string;
}

export interface EmployeeStandardMatrixResponse {
  groupId: string;
  standards: EmployeeStandardResponse[];
  users: EmployeeStandardUserResponse[];
  cells: EmployeeStandardCellResponse[];
}

export interface EmployeeStandardMatrixRequest {
  userIds: string[];
}

export interface EmployeeStandardUpdateRequest {
  standardIds: string[];
  userIds: string[];
  assigned: boolean;
}

export interface EmployeeStandardSelectableUser {
  id: string;
  displayName: string;
  positionName: string;
  isSelected: boolean;
}

export interface EmployeeStandardMatrixUser {
  id: string;
  displayName: string;
  positionName: string;
}

export interface EmployeeStandardCellReference {
  standardId: string;
  userId: string;
}

export interface EmployeeStandardCellView extends EmployeeStandardCellReference {
  id: string;
  status: EmployeeStandardCellStatus;
  statusKey: string;
  isChecked: boolean;
  originalChecked: boolean;
  isDisabled: boolean;
  isChanged: boolean;
  isActiveFromOtherGroup: boolean;
}

export interface EmployeeStandardRowView {
  id: string;
  number: string;
  name: string;
  cells: EmployeeStandardCellView[];
}

export interface EmployeeStandardCellResponseMap {
  [cellKey: string]: EmployeeStandardCellResponse;
}

export interface EmployeeStandardOverridesState {
  users: EmployeeStandardSelectableUser[];
  matrixUsers: EmployeeStandardMatrixUser[];
  rows: EmployeeStandardRowView[];
  selectedCount: number;
  changedCount: number;
  isUsersLoading: boolean;
  isMatrixLoading: boolean;
  isSaving: boolean;
  step: string;
}

export interface EmployeeStandardOverridesStatePatch {
  users?: EmployeeStandardSelectableUser[];
  matrixUsers?: EmployeeStandardMatrixUser[];
  rows?: EmployeeStandardRowView[];
  selectedCount?: number;
  changedCount?: number;
  isUsersLoading?: boolean;
  isMatrixLoading?: boolean;
  isSaving?: boolean;
  step?: string;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/employee-standard-overrides.model.ts